import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { dropEmptyValues } from '../../utils/common';
import { type GetProductsParams, getProductsCount } from '@apis/product';

export const useProductCount = (searchParam: GetProductsParams) => {
  const cleanParams = dropEmptyValues(searchParam, [
    'productCode',
    'productName',
    'stockId',
    'countryId',
    'productStatus',
    'productSaleType',
  ]);

  const queryOptions: UseQueryOptions<number, Error> = {
    // IMPORTANT:
    // Include cleanParams so the count refreshes when filters change.
    queryKey: ['productsCount', cleanParams],
    queryFn: () => getProductsCount(cleanParams),
  };

  return useQuery(queryOptions);
};
